import { FC } from "react";
import { formatNumberWithSpaces } from "../../../utils/numbers";
import currencyWhiteIcon from '../../../icons/currency-white.png';
import styles from "./BuyButton.module.scss";
import { IButtonProps } from "../Button/Button";
import { Highlightable } from "../../Highlight/Highlightable";
import { ActionPromptType } from "../../../hooks/prompts";

export interface IBuyButtonProps extends IButtonProps {
    cost: number;
    promptType?: ActionPromptType;
}

export const BuyButton: FC<IBuyButtonProps> = ({ cost, caption, handler, promptType = ActionPromptType.NONE }) => {
    return (
        <Highlightable promptType={ promptType } highlightClass={ styles.highlight } >
            <button className={styles.buyButton} onClick={ handler }>
                { `${caption} ` }
                <span className={styles.buyPrice}>
                    <img src={currencyWhiteIcon} alt="Currency" />
                    { formatNumberWithSpaces(cost) }
                </span>
            </button>
        </Highlightable>
    );
}